<template>
    <router-link v-if="$common.basic.chempty(info.url)" :to="forceurl||info.x_url" :title="linktype=='btn'?'':info.title" class="overparent">
        <img v-if="linktype=='image'" :src="info.cover" />
        <template v-else-if="linktype=='content'">
            {{$common.basic.strgetlen($common.langinfo( info.content,info.content_en),info.x_lencontent)}}
        </template>
        <template v-else-if="linktype=='btn'">
            {{info.x_btn}}
        </template>
        <template v-else>
            <ffoverdot :title="info.title" :title_en="info.title_en" :needtitle="true"></ffoverdot>
        </template>
    </router-link>
    <a v-else href="info.url" target="_blank" :title="linktype=='btn'?'':info.title" class="overparent">
        <img v-if="linktype=='image'" :src="info.cover" />
        <template v-else-if="linktype=='content'">
            {{$common.basic.strgetlen($common.langinfo( info.content,info.content_en),info.x_lencontent)}}
        </template>
        <template v-else-if="linktype=='btn'">
            {{info.x_btn}}
        </template>
        <template v-else>
            <ffoverdot :title="info.title" :title_en="info.title_en" :needtitle="true"></ffoverdot>
        </template>
    </a>
</template>

<script>
    export default {
        name: 'fflink',
        props: {
            info: {
                type: Object,
                default: () => { }
            },
            linktype: {
                type: String,
                default: ''
            },
            forceurl: {
                type: String,
                default: ''
            }
        }
    }
</script>
